<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="20vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal">
      <div class="flex justify-center mt-5 md:mt-10"><check-icon-2 /></div>
      <div
        style="word-break: normal"
        class="text-sm md:text-xl mt-4 font-semibold w-4/5 md:w-2/4 lg:w-3/5 mx-auto text-center text-root-2 flex justify-center"
      >
        Beneficiary Added Successfully!
      </div>
      <div
        class="text-xs md:text-sm text-center text-root-4 md:w-9/12 lg:w-11/12 mx-auto"
      >
        <p style="word-break: normal" class="my-3">
          Your beneficiary has been created and added successfully!
        </p>
      </div>

      <div class="mx-4 border-none my-4 pb-2 flex w-full justify-center">
        <div
          class="flex items-center justify-center mr-4 md:mr-0 bg-primary text-white w-1/2 rounded-xl cursor-pointer py-3 md:text-sm text-xs font-light"
          @click="showPendingBeneficiary"
        >
          Continue
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    showPendingBeneficiary () {
      this.$emit('processingBeneficiaryHandler')
      this.handleClose()
    },
    closeDrawer () {
      this.$emit('closeProcessingBeneficiaryHandler')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    CheckIcon2: () => import('@/assets/icons/CheckMarkIcon.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
